const AceHighwayResponseApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/response/get`,
    DOWNLOAD_FILE: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/response/downloadFile`,
    GET_AUDIT_LOGS: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/cng-admin/audit-header/get`
  };
  
  export default AceHighwayResponseApiUrls;
  